import React, { Fragment } from 'react';
import ReactDom from 'react-dom';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ViewGRN from '@Components/Purchase/GoodsReceiving/GoodsReceivingHome/ViewGRN';
import ViewProduct from '@Components/Inventory/ManageProducts/ViewProduct';
import { faShareFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import H3Image from '../../../../uilib/h3Image';

export default function PRZModal({
  children, className, isOpen, onClose, dontShowHeader, title, noHeaderBorder,
  entityType, documentId, tenantId, customStyle,
}) {
  if (!isOpen) return null;
  const entityViews = {
    grn: {
      title: 'View GRN',
      component: <ViewGRN selectedGrnId={documentId} selectedTenantId={tenantId} isQuickView />,
      documentLink: `/inventory/product/view/${documentId}`,
    },
    product: {
      title: 'Product Information',
      component: <ViewProduct productSkuId={documentId} przModalView />,
      documentLink: `/inventory/product/view/${documentId}`,
    },
  };
  const modalTitle = title || entityViews[entityType]?.title;

  const userMenuConfig = JSON.parse(localStorage.getItem("user_menu_config"));

  return ReactDom.createPortal(
    <Fragment>
      <div className="prz-modal__overlay" />
      <div className={`prz-modal__wrapper ${className || ''} ${userMenuConfig === "COLLAPSIBLE" ? 'prz-modal-collapsible' : 'prz-modal-fixed'}`} style={customStyle}>
        <div className={`prz-modal__title ${noHeaderBorder ? 'prz-modal__title-no-border' : ''}`}>
          {!dontShowHeader && (
            <H3Text
              text={modalTitle}
              className="prz-modal__title-text"
            />
          )}
          {entityViews[entityType]?.documentLink && (
            <FontAwesomeIcon
              onClick={() => window.open(entityViews[entityType]?.documentLink, '_blank')}
              icon={faShareFromSquare}
              className="prz-modal_redirect-icon"
            />
          )}
          <H3Image
            src={closeIcon}
            className="prz-modal__close-icon"
            onClick={onClose}
          />
        </div>
        {entityViews[entityType]?.component || children}
      </div>
    </Fragment>,
    document.getElementById('portal'),
  );
}
